<div class="mb-4 hidden-print">
  <div class="form-group form-row">
    <div class="col-9 col-sm-6 quiz-numerical-input">
      <input [disabled]="showFeedback || isOffline" (change)="onValueChanged($event)" aria-label="numerical question feedback"
        class="form-control" type="number" id="{{question.id}}">
    </div>
    <div class="col-3 col-sm-6 d-flex align-items-center">
      @if (showFeedback && isCorrect) {
        <span class="icon-gecko-check text-success ml-1"></span>
      }
      @if (showFeedback && !isCorrect) {
        <span class="icon-gecko-delete text-warning ml-1"></span>
      }
    </div>
  </div>
  @if (showFeedback && isCorrect && question.correctCommentsHtml!=null) {
    <div ebsTechnicalContent id="correctFeedback" class="text-info small" [innerContent]="question.correctCommentsHtml"></div>
  }
  @if (showFeedback && !isCorrect && question.incorrectCommentsHtml!=null) {
    <div ebsTechnicalContent id="incorrectFeedback" class="text-info small" [innerContent]="question.incorrectCommentsHtml"></div>
  }
  @if (showFeedback && question.neutralCommentsHtml!=null) {
    <div ebsTechnicalContent id="neutralFeedback" class="text-info small" [innerContent]="question.neutralCommentsHtml"></div>
  }
</div>
<div class="d-none d-print-block">
  <p class="numerical-question-print-box">
  </p>
</div>



